import React, { useEffect, useState, useContext } from 'react';
import { useNavigate, Link } from "react-router-dom"

import { MeuContexto } from "../App"
import { global } from '../api/global'
import { data_user } from '../api/datauser'
import { validar } from '../api/apiValidar'

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Button from '../components/Button.jsx';
import Input from '../components/Input.jsx';
import CompActive from '../components/CompActive.jsx';

function PgSignUp() {
    let navigate = useNavigate();
    const { logado, setlogado } = useContext(MeuContexto)

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [email, setEmail] = useState('');
    const [cpf, setCpf] = useState('');
    const [artist, setartist] = useState(false)
    const [isArtist, setIsArtist] = useState(false);
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const [vusername, setvusername] = useState(true)
    const [vemail, setvemail] = useState(true)
    const [vpassword, setvpassword] = useState(true)
    const [vcpf, setvcpf] = useState(true)

    useEffect(
        () => {
            if (logado) { navigate("/") }
        }, [logado])

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    function _validar() {
        let retorno = true
        let formErrors = {};

        // Validação básica para os campos
        if (!username) formErrors.username = 'Por favor, insira seu nome de usuário.';
        if (!password) formErrors.password = 'Por favor, insira sua senha.';
        if (!email) {
            formErrors.email = 'Por favor, insira seu e-mail.';
        } else if (!validateEmail(email)) {
            formErrors.email = 'Por favor, insira um e-mail válido.';
        }
        if (isArtist && !cpf) {
            formErrors.cpf = 'Por favor, insira seu CPF.';
        }

        if (Object.keys(formErrors).length === 0) {
           // console.log('Conta criada com sucesso!');
            // Aqui você pode adicionar a lógica de criação de conta
            let retorno = true
        } else {
            retorno = false
            setErrors(formErrors);
        }

        return retorno
    }

    async function _Criarconta(e) {
        e.preventDefault();
        if (_validar()) {
            setIsLoading(true);
            try {
                const resposta = await data_user.novo({ username, email, password, artist, cpf });
                if (resposta) {
                    const resposta2 = await data_user.conectar({ email, password });
                    if (resposta2) {
                        global.token = resposta2.token
                        setlogado(true)
                        toast.success('Conta criada com sucesso!');
                        navigate("/")
                    }
                }
            } catch (error) {
                toast.error('Favor verificar suas informações!');
            } finally {
                setIsLoading(false);
            }
        } else {
            toast.warn('Favor verificar suas informações!');
        }
    }

    return (
        <main className="min-h-screen bg-background flex items-center justify-center p-4 selection:bg-primary/30">
            <div className="w-full max-w-md bg-surface border border-border rounded-2xl shadow-2xl p-8 animate-fade-in-up">
                {/* Header */}
                <div className="text-center mb-8">
                    <h1 className="text-4xl font-display font-bold text-text mb-2">
                        Criar Conta
                    </h1>
                    <p className="text-text-subtle">
                        Junte-se à nossa comunidade para começar a assistir.
                    </p>
                </div>

                {/* Form */}
                <form onSubmit={_Criarconta} className="space-y-6">
                    <Input
                        label="Nome de Usuário"
                        type="text"
                        id="username"
                        name="username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        error={errors.username}
                        required
                        disabled={isLoading}
                    />
                    <Input
                        label="E-mail"
                        type="email"
                        id="email"
                        name="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        error={errors.email}
                        required
                        autoComplete="email"
                        disabled={isLoading}
                    />
                    <Input
                        label="Senha"
                        type="password"
                        id="password"
                        name="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        error={errors.password}
                        required
                        autoComplete="new-password"
                        disabled={isLoading}
                    />

                    {/* Artist Checkbox */}
                    <div className="flex items-center space-x-3 pt-2">
                        <input
                            type="checkbox"
                            id="isArtist"
                            checked={isArtist}
                            onChange={(e) => {
                                setIsArtist(e.target.checked)
                                setartist(e.target.checked)
                            }}
                            disabled={isLoading}
                            className="w-5 h-5 bg-surface border-border text-primary rounded focus:ring-primary focus:ring-2 focus:ring-offset-surface"
                        />
                        <label htmlFor="isArtist" className="text-text-subtle font-medium select-none">
                           Sou um Artista
                        </label>
                    </div>

                    {/* Conditional CPF Field */}
                    {isArtist && (
                        <div className="animate-fade-in">
                            <Input
                                label="CPF"
                                type="text"
                                id="cpf"
                                name="cpf"
                                value={cpf}
                                onChange={(e) => setCpf(e.target.value)}
                                error={errors.cpf}
                                required
                                disabled={isLoading}
                            />
                        </div>
                    )}

                    <Button
                        type="submit"
                        variant="primary"
                        size="lg"
                        className="w-full"
                        loading={isLoading}
                        disabled={isLoading}
                    >
                        {isLoading ? 'Criando Conta...' : 'Criar Conta'}
                    </Button>
                </form>

                {/* Link to Sign In */}
                <div className="text-center mt-8">
                    <p className="text-sm text-text-subtle">
                        Já tem uma conta?{' '}
                        <Link 
                            to="/SignIn"
                            className="font-medium text-primary-light hover:text-primary-dark transition-colors duration-200 focus:outline-none focus:underline"
                        >
                            Entrar
                        </Link>
                    </p>
                </div>
            </div>

            {/* Loading overlay */}
            {isLoading && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <CompActive size="lg" text="Criando sua conta..." />
                </div>
            )}

            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
            />
        </main>
    );
}

export default PgSignUp;